// extracted by mini-css-extract-plugin
module.exports = {"container":"AppNewsEdition_container__2Sb3W","sectionSeparator":"AppNewsEdition_sectionSeparator__NKIge"};